"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.85 5.7A2.7 2.7 0 0 1 5.55 3h1.633a2.7 2.7 0 0 1 2.7 2.7v1.533a2.7 2.7 0 0 1-2.7 2.7H5.55a2.7 2.7 0 0 1-2.7-2.7zm2.7-1.3a1.3 1.3 0 0 0-1.3 1.3v1.533a1.3 1.3 0 0 0 1.3 1.3h1.633a1.3 1.3 0 0 0 1.3-1.3V5.7a1.3 1.3 0 0 0-1.3-1.3zm8.567 12.367a2.7 2.7 0 0 1 2.7-2.7h1.633a2.7 2.7 0 0 1 2.7 2.7V18.3a2.7 2.7 0 0 1-2.7 2.7h-1.633a2.7 2.7 0 0 1-2.7-2.7zm2.7-1.3a1.3 1.3 0 0 0-1.3 1.3V18.3a1.3 1.3 0 0 0 1.3 1.3h1.633a1.3 1.3 0 0 0 1.3-1.3v-1.533a1.3 1.3 0 0 0-1.3-1.3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.792 6.807H8.5v-1.4h.292a.7.7 0 1 1 0 1.4m2.216-.7a.7.7 0 0 1 .7-.7h.542a.7.7 0 1 1 0 1.4h-.542a.7.7 0 0 1-.7-.7m3.042 0a.7.7 0 0 1 .7-.7H15q.245 0 .482.03a.7.7 0 0 1-.18 1.389 2 2 0 0 0-.302-.02h-.25a.7.7 0 0 1-.7-.7m3.834 1.914a.7.7 0 0 1 .785.603q.03.238.031.483v.24a.7.7 0 0 1-1.4 0v-.24q0-.154-.02-.302a.7.7 0 0 1 .604-.784M5.3 8.849v-.287h1.4v.287a.7.7 0 1 1-1.4 0m.7 2.165a.7.7 0 0 1 .7.7v.527a.7.7 0 1 1-1.4 0v-.527a.7.7 0 0 1 .7-.7m12 .045a.7.7 0 0 1 .7.7v.527a.7.7 0 1 1-1.4 0v-.527a.7.7 0 0 1 .7-.7M6 13.952a.7.7 0 0 1 .7.7v.242q0 .154.02.3a.7.7 0 0 1-1.389.182 4 4 0 0 1-.03-.482v-.242a.7.7 0 0 1 .7-.7m12 .5a.7.7 0 0 1 .7.7v.286h-1.4v-.287a.7.7 0 0 1 .7-.7M7.914 17.777a.7.7 0 0 1 .785-.604q.147.02.301.02h.25a.7.7 0 1 1 0 1.4H9q-.245 0-.482-.032a.7.7 0 0 1-.604-.784m3.136.116a.7.7 0 0 1 .7-.7h.542a.7.7 0 1 1 0 1.4h-.542a.7.7 0 0 1-.7-.7m3.458 0a.7.7 0 0 1 .7-.7h.292v1.4h-.292a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ProofBoxDashedIcon24.js.map